import { Component, Renderer2 } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular';

@Component({
  selector: 'on-time-percentage-modal',
  templateUrl: 'on-time-percentage-modal.html',
})
export class OnTimePercentageModalComponent {
  title: string;
  percentageString: string;
  onTimePercentage: number;
  onTimeStatusMessage: string;
  actionButtonText: string;

  constructor(
    private navParams: NavParams,
    private renderer: Renderer2,
    private viewCtrl: ViewController
  ) {
    this.renderer.addClass(
      this.viewCtrl.pageRef().nativeElement,
      'on-time-percentage-modal'
    );
    this.title = 'Your on-time percentage today is';
    this.actionButtonText = 'okay';
    this.onTimePercentage = this.navParams.get('onTimePercentage');
    this.onTimeStatusMessage = this.messageForCompletedOnTimePercentage();
    this.percentageString =
      Math.round(this.onTimePercentage) +
      '% ' +
      this.emojiForCompletedOnTimePercentage();
  }

  // actions
  didTapActionBtn() {
    this.viewCtrl.dismiss();
  }

  // helpers
  messageForCompletedOnTimePercentage(): string {
    if (this.onTimePercentage <= 59) {
      return CompletedOnTimeStatusMessages.ThingsDontLookGood;
    } else if (this.onTimePercentage <= 79) {
      return CompletedOnTimeStatusMessages.CustomersAreCountingOnYou;
    } else if (this.onTimePercentage >= 80 && this.onTimePercentage <= 89) {
      return CompletedOnTimeStatusMessages.Nice;
    } else if (this.onTimePercentage >= 90 && this.onTimePercentage <= 100) {
      return CompletedOnTimeStatusMessages.GreatWork;
    }
  }

  emojiForCompletedOnTimePercentage(): string {
    if (this.onTimePercentage < 50) {
      return '😬';
    } else if (this.onTimePercentage >= 50 && this.onTimePercentage <= 59) {
      return '☹️';
    } else if (this.onTimePercentage >= 60 && this.onTimePercentage <= 69) {
      return '😕';
    } else if (this.onTimePercentage >= 70 && this.onTimePercentage <= 79) {
      return '🤔';
    } else if (this.onTimePercentage >= 80 && this.onTimePercentage <= 89) {
      return '🙂';
    } else if (this.onTimePercentage >= 90 && this.onTimePercentage <= 100) {
      return '💪';
    }
  }
}

enum CompletedOnTimeStatusMessages {
  GreatWork = 'Great work! We send ETAs to customers at the beginning of the day and they love it when you’re on time!',
  Nice = 'Nice. We send ETAs to customers at the beginning of the day and they love it when you’re on time!',
  CustomersAreCountingOnYou = 'Your customers are counting on you to be on time. Contact your supervisor if you need assistance getting back on track.',
  ThingsDontLookGood = 'Looks like something is going very wrong with your route today. Contact your supervisor to help us understand what is going wrong.',
}



// WEBPACK FOOTER //
// ./src/components/on-time-percentage-modal/on-time-percentage-modal.ts